import CRUDService from "../../services/base/CRUDService";

export default class IntegrationUserService extends CRUDService {

  static ALL_URL = 'auth/v1/integration-users/';

  getBaseURL() {
    return IntegrationUserService.ALL_URL;
  }

  saveProfiles(id, profileIds) {
    return this.getHttpRequest().put(`${this.getBaseURL()}${id}/profiles`, profileIds);
  }

}



// WEBPACK FOOTER //
// ./src/user/integration/IntegrationUserService.js